import React, { useEffect, useState } from "react";
import { Input, InputNumber } from "antd";
import { SeatDistribution } from "../../../enums/SeatDistributionEnum";
import {
    isLetterDistribution,
    startsAtToLetter,
    letterToStartsAt,
    startsAtToDisplayNumber,
    displayNumberToStartsAt,
} from "../../../utils/SeatDistributionUtil";

export const StartsAtInput = React.forwardRef(
    ({ distributionKey, value, onChange }, ref) => {
        const letterMode = isLetterDistribution(distributionKey);
        const upperCase = distributionKey === SeatDistribution.UPPER_CASE;

        const [text, setText] = useState(() =>
            startsAtToLetter(value ?? 1, upperCase)
        );

        useEffect(() => {
            if (letterMode) {
                setText(startsAtToLetter(value ?? 1, upperCase));
            }
        }, [value, letterMode, upperCase]);

        if (!letterMode) {
            return (
                <InputNumber
                    ref={ref}
                    min={1}
                    value={startsAtToDisplayNumber(distributionKey, value ?? 1)}
                    onChange={(display) =>
                        onChange &&
                        onChange(
                            displayNumberToStartsAt(
                                distributionKey,
                                display ?? 1
                            )
                        )
                    }
                />
            );
        }

        const handleChange = (event) => {
            const raw = event.target.value ?? "";
            const filtered = raw.replace(/[^a-zA-Z]/g, "");
            const normalized = upperCase
                ? filtered.toUpperCase()
                : filtered.toLowerCase();

            setText(normalized);

            if (normalized === "") return;

            onChange && onChange(letterToStartsAt(normalized));
        };

        const handleBlur = () => {
            if (text === "") {
                const fallback = startsAtToLetter(1, upperCase);
                setText(fallback);
                onChange && onChange(1);
            }
        };

        return (
            <Input
                ref={ref}
                value={text}
                onChange={handleChange}
                onBlur={handleBlur}
            />
        );
    }
);
